// Tyler.API.Searching.InputType
export enum InputType {
    Text = 0,
    Select = 1,
    DEPRECATED_Multiselect = 2,
    Number = 3,
    Date = 4,
    Boolean = 5,
    Typeahead = 6,
    Guid = 7,
    DEPRECATED_Mask = 8,
    Decimal = 9,
    Metadata = 10,
    DEPRECATED_Color = 11
}
